var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9117 0.683773C4.04781 0.275431 4.42995 0 4.86038 0H9.13962C9.57005 0 9.95219 0.275431 10.0883 0.683773L10.8604 3H14V4H12.963L12.1051 15.1534C12.0249 16.1954 11.156 17 10.111 17H3.88905C2.84397 17 1.97509 16.1954 1.89494 15.1534L1.03698 4H0V3H3.13962L3.9117 0.683773ZM4.19371 3H9.80629L9.13962 1H4.86038L4.19371 3ZM2.03994 4L2.89199 15.0767C2.93207 15.5977 3.36651 16 3.88905 16H10.111C10.6335 16 11.0679 15.5977 11.108 15.0767L11.9601 4H2.03994ZM6.5 13V7H7.5V13H6.5Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.6aaeb68899671f56be7c2a60fa79e5d1.svg";
export { ForwardRef as ReactComponent };